import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './SubTitle.styles';

const SubTitle = ({ children }) => (
  <Wrapper>
    {children}
  </Wrapper>
);

SubTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default SubTitle;
